import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { IOnlyUserProfile } from "../types/Types";

/**
 * @author mb
 */
export const UserRoleAPI = createApi({
    reducerPath: "UserRoleAPI",
    baseQuery: fetchBaseQuery(
        {
            baseUrl: process.env.REACT_APP_API_URL! + process.env.REACT_APP_API_VERSION! + "userrole",
            credentials: 'include'
        }),
    tagTypes: ['adminProfileAPI'], // for caching
    endpoints: (builder) => ({
      
        getUserProfiles: builder.mutation<IOnlyUserProfile[], void>(
            {
                query: () => ({
                    url: `onlyUserProfiles`,
                    method: 'get',
                    credentials: 'include',
                })
            }
        ),
        
       
    })
});

export const {
    
    useGetUserProfilesMutation,

} = UserRoleAPI;
